import { render, staticRenderFns } from "./bloodPressureMonitor.vue?vue&type=template&id=7ff9c2ac&scoped=true"
import script from "./bloodPressureMonitor.vue?vue&type=script&lang=js"
export * from "./bloodPressureMonitor.vue?vue&type=script&lang=js"
import style0 from "./bloodPressureMonitor.vue?vue&type=style&index=0&id=7ff9c2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff9c2ac",
  null
  
)

export default component.exports